export default "__VITE_ASSET__D6QAUtZ7__"